module.exports = __webpack_public_path__ + "assets/a5e11f6801c2a6b4403aec494efa759e.png";